import { css } from '@emotion/react'
import { Flow, Icon, Icons, Text, Tooltip } from 'bold-ui'
import { gray } from 'bold-ui/lib/styles/colors'
import { GrupoRisco, Risco } from 'graphql/types.generated'

import { RastreamentosEstratificacaoTag } from './RastreamentosEstratificacaoTag'

interface RastreamentosListCardProps {
  riscos: ReadonlyArray<Risco>
}

const GRUPO_RISCO_MAP: Record<GrupoRisco, { icon: Icons; titulo: string }> = {
  [GrupoRisco.CARDIOVASCULAR]: { icon: 'heartRateFilled', titulo: 'Risco Cardiovascular' },
  [GrupoRisco.DENGUE]: { icon: 'infoCircleFilled', titulo: 'Risco de Dengue' },
  [GrupoRisco.PRE_ECLAMPSIA]: { icon: 'infoCircleFilled', titulo: 'Risco de Pré-eclâmpsia' },
}

export function RastreamentosListCard(props: Readonly<RastreamentosListCardProps>) {
  const { riscos } = props

  return (
    <Flow direction='vertical' gap={0.5}>
      {riscos.map((risco) => {
        const { estratificacao, origem, descricaoOrigem, grupo } = risco
        const { icon, titulo } = grupo ? GRUPO_RISCO_MAP[grupo] : {}
        const isOrigemCalculadora = origem?.includes('\n') ?? false
        const [origemCalculadora, origemSdc] = isOrigemCalculadora ? origem!.split('\n') : [null, origem]

        return (
          <Flow
            direction='horizontal'
            gap={0.5}
            key={`${grupo ?? 'SEM_GRUPO'}-${estratificacao ?? 'SEM_ESTRATIFICACAO'}`}
          >
            <Icon icon={icon} color={gray.c40} />
            <Flow direction='vertical' gap={0.25}>
              <Flow direction='horizontal' gap={0.5} alignItems='center'>
                <Text fontWeight='bold'>{titulo}</Text>
              </Flow>
              {estratificacao && (
                <Flow direction='vertical' style={styles.estratificacaoTag}>
                  <RastreamentosEstratificacaoTag estratificacao={estratificacao} />
                </Flow>
              )}
              <Flow direction='horizontal' gap={0.5} alignItems='center'>
                {origem && (
                  <Flow direction='vertical' gap={0.25}>
                    <Text>{origemCalculadora}</Text>
                    <Flow direction='horizontal' alignItems='center' gap={0.5}>
                      <Text fontStyle='italic' style={styles.origemSdcText}>
                        {origemSdc}
                      </Text>
                      {descricaoOrigem && (
                        <Tooltip text={descricaoOrigem}>
                          <Icon icon='infoCircleFilled' size={1} />
                        </Tooltip>
                      )}
                    </Flow>
                  </Flow>
                )}
              </Flow>
            </Flow>
          </Flow>
        )
      })}
    </Flow>
  )
}

const styles = {
  origemSdcText: css`
    color: ${gray.c40};
  `,
  estratificacaoTag: css`
    justify-self: start;
  `,
}
